import React from 'react';
import { connect } from 'react-redux';
import SecurityService from './securityService.js';

class LogoutContainer extends React.Component {
  componentDidMount() {
    SecurityService.signOut(this.props.idToken);
  }

  render() {
    return null;
  }
}

const mapStatetoProps = (state) => {
  return {
    idToken: state.auth.idToken,
  };
};

export default connect(mapStatetoProps)(LogoutContainer);
